import React from "react";
import "./WhyOnlineMBA.css"
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";

const WhyOnlineMBA = () => {
  return (
    <section className="WhyOnlineMBA">
      <div className="container">

         <Main_heading_holder
          heading="Why "
          spanHeading="Online MBA"
          subHeading="Built for people who refuse to pause their careers"
          headingType="h2"
        />
        <div className="benefits-grid ">
          <div className="benefit-card">
            <span className="benefit-num">01</span>
            <h4>Flexible Learning</h4>
            <p>
              Study at your own pace, on your own schedule, without stepping
              away from your job.
            </p>
          </div>
          <div className="benefit-card">
            <span className="benefit-num">02</span>
            <h4>Career Growth</h4>
            <p>
              Built for working professionals aiming at leadership roles and
              faster promotions.
            </p>
          </div>
          <div className="benefit-card">
            <span className="benefit-num">03</span>
            <h4>Industry-Aligned Tracks</h4>
            <p>
              Specializations mapped to what today's hiring managers are
              actually looking for.
            </p>
          </div>
          <div className="benefit-card">
            <span className="benefit-num">04</span>
            <h4>Stronger Earning Potential</h4>
            <p>
              Graduates consistently report improved compensation after
              completing the program.
            </p>
          </div>
          <div className="benefit-card">
            <span className="benefit-num">05</span>
            <h4>Global Peer Network</h4>
            <p>
              Learn alongside professionals and faculty from a wide range of
              industries and geographies.
            </p>
          </div>
          <div className="benefit-card">
            <span className="benefit-num">06</span>
            <h4>Lower Cost, Same Rigor</h4>
            <p>
              A fraction of the cost of a traditional on-campus MBA, with
              comparable accreditation.
            </p>
          </div>
          <div className="benefit-card">
            <span className="benefit-num">07</span>
            <h4>Leadership Skillset</h4>
            <p>
              Strategic thinking, decision-making and problem-solving —
              practiced through real cases.
            </p>
          </div>
          <div className="benefit-card">
            <span className="benefit-num">08</span>
            <h4>Recognized Degree</h4>
            <p>
              UGC-approved programs from NAAC A+ / A++ accredited universities.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyOnlineMBA;
